// store.js
import type { BeforeNavigate } from '@sveltejs/kit';
import { get, writable } from 'svelte/store';
import { t } from './i18n';

export const selectedMenuEntry = writable<string | null>(null);
export const onMouseMoveStore = writable<MouseEvent | null>(null);
export const onMouseUpStore = writable<MouseEvent | null>(null);
export const isOnline = writable<boolean>(true);

export const mouseX = writable<number>(0);
export const mouseY = writable<number>(0);
export const clicked = writable<Event | null>(null);
export const isTouchDevice = writable<boolean>(false);

export const mobileButtonOpened = writable<string>('');
export const pageTitle = writable<string>('');
export const backgroundColor = writable<number>(7);

export function mouseInsideElt(elt: HTMLElement | undefined, x: number, y: number) {
	if (!elt) return false;
	const rect = elt.getBoundingClientRect();
	return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
}

export function downloadData(data: string, filename: string) {
	// Download the file
	const url = window.URL.createObjectURL(new Blob([data]));
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', filename);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

export function checkUnsavedChanges(nav: BeforeNavigate, hasUnsavedChanges: boolean) {
	if (hasUnsavedChanges) {
		const confirmed = confirm(get(t)('form.unsaved_changes_confirm'));
		if (!confirmed) {
			nav.cancel();
		}
	}
}
